export var NewContextMenuItemType;
(function (NewContextMenuItemType) {
    NewContextMenuItemType[NewContextMenuItemType["Separator"] = 0] = "Separator";
    NewContextMenuItemType[NewContextMenuItemType["Default"] = 1] = "Default";
    NewContextMenuItemType[NewContextMenuItemType["Account"] = 2] = "Account";
    NewContextMenuItemType[NewContextMenuItemType["AccountLookup"] = 3] = "AccountLookup";
    NewContextMenuItemType[NewContextMenuItemType["Image"] = 4] = "Image";
    NewContextMenuItemType[NewContextMenuItemType["ExternalTool"] = 5] = "ExternalTool";
})(NewContextMenuItemType || (NewContextMenuItemType = {}));
export function createContextMenuItemsFromEnum(enumObject, getLocalizationKey, isAddFilter = null, getTooltipLocalizationKey = null) {
    const result = [];
    const values = Object.values(enumObject).filter((value) => typeof value === 'number');
    for (let i = 0; i < values.length; i++) {
        const value = values[i];
        if (!isNullOrUndefined(isAddFilter) && !isAddFilter(value)) {
            continue;
        }
        const key = getLocalizationKey(value);
        const tooltip = !isNullOrUndefined(getTooltipLocalizationKey) ? getTooltipLocalizationKey(value) : null;
        result.push({ type: NewContextMenuItemType.Default, text: key, value: value, tooltip: tooltip });
    }
    return result;
}
export function getMenuHeight(itemsCount) {
    const heightOfElement = 32;
    const padding = 4;
    return itemsCount * heightOfElement + padding * 2;
}
export function createTagDictionary(newValues) {
    const res = {};
    processTagDictCreation(newValues, res);
    return res;
}
function processTagDictCreation(items, resultArray) {
    var _a;
    const len = items.length;
    for (let i = 0; i < len; i++) {
        const curItem = items[i];
        resultArray[curItem.tag] = curItem;
        if (((_a = curItem.subitems) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            processTagDictCreation(curItem.subitems, resultArray);
        }
    }
}
